(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/change-password/components/change-password-form.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/change-password/components/change-password-form.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const TextInput = svs.ui.reactFormInputs.TextInput;
const Form = svs.ui.reactForm.Form;
const Button = svs.ui.ReactButton;
const _svs$ticket_partner$c = svs.ticket_partner.changePassword.constants.FORMS,
  PASSWORD_OLD = _svs$ticket_partner$c.PASSWORD_OLD,
  PASSWORD = _svs$ticket_partner$c.PASSWORD,
  PASSWORD_REPEAT = _svs$ticket_partner$c.PASSWORD_REPEAT,
  BUTTON_CANCEL_LABEL = _svs$ticket_partner$c.BUTTON_CANCEL_LABEL,
  BUTTON_CONFIRM_LABEL = _svs$ticket_partner$c.BUTTON_CONFIRM_LABEL,
  INVALID_PASSWORD_ERROR_MESSAGE = _svs$ticket_partner$c.INVALID_PASSWORD_ERROR_MESSAGE,
  PASSWORD_NOT_MATCHING_ERROR_MESSAGE = _svs$ticket_partner$c.PASSWORD_NOT_MATCHING_ERROR_MESSAGE,
  PASSWORD_UPDATED_TITLE = _svs$ticket_partner$c.PASSWORD_UPDATED_TITLE,
  PASSWORD_UPDATED_MESSAGE = _svs$ticket_partner$c.PASSWORD_UPDATED_MESSAGE;
const _React = React,
  useState = _React.useState;
const ButtonRow = svs.ticket_partner.sharedComponents.buttonRow.ButtonRow;
const validateNewPasswordFormat = password => {
  const passWordReg = /^((?=.*[a-zA-Z])(?=.*\d)(?:[0-9a-zA-Z.@-]){8,18})$/;
  return passWordReg.test(password);
};
const ChangePasswordForm = _ref => {
  let customButtons = _ref.customButtons,
    onCancel = _ref.onCancel,
    onPasswordChanged = _ref.onPasswordChanged,
    _ref$isVertical = _ref.isVertical,
    isVertical = _ref$isVertical === void 0 ? true : _ref$isVertical,
    _ref$isLessSpace = _ref.isLessSpace,
    isLessSpace = _ref$isLessSpace === void 0 ? false : _ref$isLessSpace;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    oldPassword = _useState2[0],
    setOldPassword = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    password = _useState4[0],
    setPassword = _useState4[1];
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    passwordRepeat = _useState6[0],
    setPasswordRepeat = _useState6[1];
  const handleSubmit = async (e, formData) => {
    e.preventDefault();
    if (_.values(formData).some(_ref2 => {
      let isValid = _ref2.isValid;
      return !isValid;
    })) {
      return;
    }
    svs.ui.loader.show();
    try {
      await svs.ticket_partner.services.changePassword(oldPassword, password);
      svs.ticket_partner.utils.showSuccessDialog(PASSWORD_UPDATED_MESSAGE, PASSWORD_UPDATED_TITLE, () => {
        setPassword('');
        setOldPassword('');
        setPasswordRepeat('');
        onPasswordChanged();
      });
    } catch (e) {
      svs.ticket_partner.utils.showErrorDialog(svs.ticket_partner.services.changePasswordErrorMapper(e));
    }
    svs.ui.loader.hide();
  };
  const validatePassword = value => {
    const isValid = validateNewPasswordFormat(value);
    return {
      isValid,
      errorMessage: isValid ? '' : INVALID_PASSWORD_ERROR_MESSAGE
    };
  };
  const validateNewPassword = value => {
    const validPassword = validatePassword(value);
    if (validPassword.isValid) {
      const isMatching = value === password;
      return {
        isValid: isMatching,
        errorMessage: isMatching ? '' : PASSWORD_NOT_MATCHING_ERROR_MESSAGE
      };
    }
    return validPassword;
  };
  return React.createElement(Form, {
    isVertical: isVertical,
    onSubmit: handleSubmit
  }, React.createElement(TextInput, {
    "data-testid": PASSWORD_OLD.NAME,
    errorMessageRequired: PASSWORD_OLD.REQUIRED_ERROR,
    id: PASSWORD_OLD.NAME,
    isLessSpace: isLessSpace,
    isRequired: true,
    label: PASSWORD_OLD.LABEL,
    name: PASSWORD_OLD.NAME,
    onChange: e => setOldPassword(e.target.value),
    type: "password",
    value: oldPassword
  }), React.createElement(TextInput, {
    "data-testid": PASSWORD.NAME,
    errorMessageRequired: PASSWORD.REQUIRED_ERROR,
    helpMessage: PASSWORD.HELP,
    id: PASSWORD.NAME,
    isLessSpace: isLessSpace,
    isRequired: true,
    label: PASSWORD.LABEL,
    name: PASSWORD.NAME,
    onChange: e => setPassword(e.target.value),
    type: "password",
    validateFn: validatePassword,
    value: password
  }), React.createElement(TextInput, {
    "data-testid": PASSWORD_REPEAT.NAME,
    errorMessageRequired: PASSWORD_REPEAT.REQUIRED_ERROR,
    helpMessage: PASSWORD_REPEAT.HELP,
    id: PASSWORD_REPEAT.NAME,
    isLessSpace: isLessSpace,
    isRequired: true,
    label: PASSWORD_REPEAT.LABEL,
    name: PASSWORD_REPEAT.NAME,
    onChange: e => setPasswordRepeat(e.target.value),
    type: "password",
    validateFn: validateNewPassword,
    value: passwordRepeat
  }), customButtons ? React.createElement(ButtonRow, {
    buttons: customButtons,
    className: "margin-top-2"
  }) : React.createElement("div", {
    className: "u-flex u-flex-justify-content-center u-flex-align-items-center margin-3"
  }, React.createElement(Button, {
    className: "margin-right-1",
    onClick: onCancel,
    transparent: true
  }, BUTTON_CANCEL_LABEL), React.createElement(Button, {
    className: "button-width-150",
    focus: true,
    inverted: true,
    type: "submit"
  }, BUTTON_CONFIRM_LABEL)));
};
svs.ticket_partner.changePassword.ChangePasswordForm = ChangePasswordForm;

 })(window);